// code splitting:
// export a copy of playerstates from here to avoid loading the whole
// nimble/player-interface module as part of the core bundle

export enum PlayerStates {
  Buffering = 'playerState:buffering',
  Ended = 'playerState:ended',
  Error = 'playerState:error',
  Paused = 'playerState:paused',
  Playing = 'playerState:playing',
  Ready = 'playerState:ready',
  Seeking = 'playerState:seeking',
  Seeked = 'playerState:seeked',
  Stopped = 'playerState:stopped',
}

export type StateChangeEvent = {
  state: PlayerStates;
};

export type TimeUpdateEvent = {
  duration: number;
  time: number;
};

export type ID3TagData = {
  sn: number;
  tag: string;
  pts: number;
};

export type ProgressBarData = {
  startValue: string;
  endValue: string;
  percent: number;
};

export type ControlsDetails = {
  // vod and live
  id: string;
  title: string;
  description: string;
  genre: string;
  classification: string;
  consumerAdvice?: string;
  displayConsumerAdvice?: boolean;
  endTimestamp: number;
  landscapeImageUrl: string;
  posterImageUrl: string;
  startTimestamp: number;
  posterLink: string;
  upNextContentApiEndpoint?: string;
  playbackEndpoint?: string;
  metadata?: string;
  showApiEndpoint?: string;

  // live data
  color?: string;
  logoUrl?: string;
  channelId?: string;

  // vod data
  showId?: string;
  seasonTitle?: string;
  isExtra?: boolean;
  altId?: string;
};

export interface ResumeWatchingData {
  seekTime: number;
  modalDuration: number;
  videoTitle: string;
}
